export const ROUTES = {
  DASHBOARD: '/dashboard',
  ORDERS: '/orders',
  ORDERS_APPOINTMENT: '/orders/appointment',
  RATE_CARD: '/rate-card',
  ADD_ORDER: '/orders/add',
  NDR: '/ndr',
  WEIGHT: '/weight',
  FINANCE: '/finance',
  WALLET: '/finance/wallet',
  INVOICE: '/finance/invoice',
  INVOICE_DETAILS: '/invoices/:invoiceNumber',
  REMITTANCE: '/finance/remittance',
  REMITTANCE_DETAILS: '/finance/remittance/:ledgerId',
  RATE_CALCULATOR: '/rate-calculator',
  SETTINGS: '/settings',
  SETTINGS_PROFILE: '/settings/profile',
  SETTINGS_SECURITY: '/settings/security',
  SETTINGS_MANAGE: '/settings/manage-courier',
  SETTINGS_CHANNEL: '/settings/channel',
  SETTINGS_WAREHOUSE: '/settings/warehouses',
  SETTINGS_WAREHOUSE_ADD: '/settings/warehouses/add',
  SETTINGS_TRANSPORT_ID: '/settings/transport-id',
  SETTINGS_PINCODE: '/settings/pincode',
  SETTINGS_LABEL: '/settings/label',
  MANAGE_USERS: '/admin/manage-users',
  UPLOAD_PINCODE: '/admin/upload-pincode',
  RECO_BILLS: '/admin/reco-bills',
  SUPPORT:'/support',
  REPORT:'/reports',
  INWARD_REMITTANCE: '/admin/inward-remittance',
  OUTWARD_REMITTANCE: '/admin/outward-remittance',
  ADMIN_SHIPMENT_CHARGES: '/admin/shipment-charges',
  ADMIN_WALLET_TRANSACTION: '/admin/wallet-transaction',
  ADMIN_RATES: '/admin/rates',
  ADMIN_USER_RATES: '/admin/manage-users/:userId/rates',
  B2B_RATES: '/b2b/rates',
  B2B_DASHBOARD: '/b2b/dashboard',
  B2B_ORDERS: '/b2b/orders',
  B2B_ADD_ORDER: '/b2b/orders/add',
  B2B_APPOINTMENT: '/b2b/appointment',
  B2B_WALLET: '/b2b/finance/wallet',
  B2B_TRANSACTIONS: '/b2b/transactions',
};
